import { Box, Typography } from '@mui/material';
import React from 'react';
import LegalDocumentLayout, { headingSx, listSx, paragraphSx } from '../../components/front/LegalDocumentLayout';

const LAST_UPDATED = '16 de junho de 2026';

function TermsOfUsePage() {
    return (
        <LegalDocumentLayout title="Termos de Uso" lastUpdated={LAST_UPDATED}>
            <Typography sx={paragraphSx}>
                Estes Termos de Uso regulam o acesso e a utilização da plataforma <strong>Acompanha 3D</strong>,
                oferecida por <strong>Andrebian Soluções Web</strong>, CNPJ 23.558.573/0001-30, com sede em Curitiba/PR
                (&quot;nós&quot;, &quot;nos&quot; ou &quot;Controlador&quot;). Ao criar uma conta ou utilizar o serviço,
                você (&quot;Usuário&quot;) declara ter lido, compreendido e aceito integralmente estes Termos.
            </Typography>

            <Typography component="h2" sx={headingSx}>1. Objeto do serviço</Typography>
            <Typography sx={paragraphSx}>
                O Acompanha 3D é uma ferramenta online de gestão voltada a makers e negócios de impressão 3D,
                incluindo controle de produção, pedidos, clientes, produtos e métricas operacionais. Funcionalidades
                podem variar conforme o plano contratado (gratuito ou pago).
            </Typography>

            <Typography component="h2" sx={headingSx}>2. Cadastro e conta</Typography>
            <Typography sx={paragraphSx}>
                Para utilizar o serviço, o Usuário deve fornecer informações verdadeiras e manter seus dados atualizados.
                O acesso pode exigir confirmação de e-mail. Você é responsável por manter a confidencialidade da senha e
                por todas as atividades realizadas em sua conta.
            </Typography>
            <Box component="ul" sx={listSx}>
                <li>É proibido criar contas em nome de terceiros sem autorização.</li>
                <li>É proibido compartilhar credenciais de acesso com outras pessoas.</li>
                <li>Notifique-nos imediatamente em caso de uso não autorizado da conta.</li>
            </Box>

            <Typography component="h2" sx={headingSx}>3. Uso aceitável</Typography>
            <Typography sx={paragraphSx}>
                O Usuário compromete-se a utilizar a plataforma de forma lícita, respeitando a legislação brasileira,
                estes Termos e os direitos de terceiros. É vedado, entre outras condutas:
            </Typography>
            <Box component="ul" sx={listSx}>
                <li>Tentar acessar áreas ou dados de outros usuários sem autorização.</li>
                <li>Interferir no funcionamento, segurança ou disponibilidade do serviço.</li>
                <li>Enviar conteúdo ilícito, ofensivo, discriminatório ou que viole direitos autorais.</li>
                <li>Utilizar a plataforma para fins de spam, fraude ou atividades maliciosas.</li>
                <li>Realizar engenharia reversa ou extração automatizada de dados sem consentimento prévio.</li>
            </Box>

            <Typography component="h2" sx={headingSx}>4. Conteúdo do usuário</Typography>
            <Typography sx={paragraphSx}>
                Os dados, textos, imagens e demais informações inseridos pelo Usuário na plataforma permanecem de sua
                titularidade. Ao utilizar o serviço, você nos concede licença limitada para armazenar, processar e exibir
                esse conteúdo exclusivamente para a prestação do serviço contratado.
            </Typography>

            <Typography component="h2" sx={headingSx}>5. Planos, preços e disponibilidade</Typography>
            <Typography sx={paragraphSx}>
                Oferecemos planos gratuitos e pagos. Recursos, limites e preços podem ser alterados mediante comunicação
                prévia na plataforma ou por e-mail. O plano gratuito pode ser oferecido por tempo indeterminado ou
                sujeito a alterações, sempre com transparência quanto às condições vigentes.
            </Typography>

            <Typography component="h2" sx={headingSx}>6. Propriedade intelectual</Typography>
            <Typography sx={paragraphSx}>
                A marca Acompanha 3D, o software, layout, textos institucionais e demais elementos da plataforma são de
                propriedade da Andrebian Soluções Web ou de seus licenciadores. Nenhuma disposição destes Termos transfere
                direitos de propriedade intelectual ao Usuário, exceto a licença de uso necessária ao funcionamento do serviço.
            </Typography>

            <Typography component="h2" sx={headingSx}>7. Privacidade e proteção de dados</Typography>
            <Typography sx={paragraphSx}>
                O tratamento de dados pessoais é regido pela nossa{' '}
                <a href="/politica-de-privacidade">Política de Privacidade</a>, em conformidade com a Lei Geral de
                Proteção de Dados (Lei nº 13.709/2018 — LGPD).
            </Typography>

            <Typography component="h2" sx={headingSx}>8. Disponibilidade e limitação de responsabilidade</Typography>
            <Typography sx={paragraphSx}>
                Empregamos esforços razoáveis para manter o serviço disponível, mas não garantimos operação ininterrupta
                ou livre de erros. O Acompanha 3D é fornecido &quot;no estado em que se encontra&quot;. Na extensão
                permitida pela lei, não nos responsabilizamos por lucros cessantes, perda de dados causada por mau uso
                do Usuário ou danos indiretos decorrentes do uso da plataforma.
            </Typography>

            <Typography component="h2" sx={headingSx}>9. Suspensão e encerramento</Typography>
            <Typography sx={paragraphSx}>
                Podemos suspender ou encerrar contas que violem estes Termos ou representem risco à segurança do serviço.
                O Usuário pode solicitar o encerramento da conta a qualquer momento, observadas as disposições da Política
                de Privacidade quanto à retenção de dados.
            </Typography>

            <Typography component="h2" sx={headingSx}>10. Alterações dos Termos</Typography>
            <Typography sx={paragraphSx}>
                Estes Termos podem ser atualizados periodicamente. A data da última revisão constará no topo desta página.
                O uso continuado do serviço após alterações implica aceitação das novas condições.
            </Typography>

            <Typography component="h2" sx={headingSx}>11. Lei aplicável e foro</Typography>
            <Typography sx={paragraphSx}>
                Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da comarca de
                Curitiba/PR para dirimir controvérsias, salvo disposição legal em contrário aplicável ao consumidor.
            </Typography>

            <Typography component="h2" sx={headingSx}>12. Contato</Typography>
            <Typography sx={paragraphSx}>
                Dúvidas sobre estes Termos podem ser enviadas para{' '}
                <a href="mailto:contato@acompanha3d.com.br">contato@acompanha3d.com.br</a>.
            </Typography>
        </LegalDocumentLayout>
    );
}

export default TermsOfUsePage;
